import { useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
// @mui
import { styled } from '@mui/material/styles';
import { Card, Container, Typography } from '@mui/material';
// hooks
import useResponsive from 'src/hooks/use-responsive';
import usePush from 'src/hooks/use-push';
// components
import Page from 'src/components/molecules/page';
import Logo from 'src/components/molecules/logo';
// sections
import LoginForm from 'src/components/molecules/login-form';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const [cookies, setCookie, removeCookie] = useCookies();
  const location = useLocation();
  const mdUp = useResponsive('up', 'md');
  const push = usePush();

  const defaultValues = {
    email: cookies.email ?? '',
    password: '',
    remember: true,
  };

  const LoginOnSubmit = (formValue: any) =>
    new Promise((resolve) => {
      if (formValue.remember) {
        setCookie('email', formValue.email);
      } else {
        removeCookie('email');
      }
      push(resolve, {
        reqProp: {
          pathKey: 'signIn',
          method: 'post',
          data: { email: formValue.email, password: formValue.password },
        },
        aftProp: {
          resolve,
          nextPath: (location.state && (location as any).state.from) ?? '/reserves',
          showMessage: {
            state: { snackBar: { open: true, viewType: 'success', message: 'ログインしました' } },
          },
        },
      });
    });

  return (
    <Page title="Login">
      <RootStyle>
        <HeaderStyle>{mdUp && <Logo />}</HeaderStyle>

        {mdUp && (
          <SectionStyle>
            <Typography variant="h3" sx={{ px: 5, mt: 0, mb: 5 }}>
              ようこそ
            </Typography>

            <img src="/static/illustrations/illustration_login.svg" alt="login" />
          </SectionStyle>
        )}

        <Container maxWidth="sm">
          <ContentStyle>
            <Typography variant="h4" gutterBottom>
              PHOTO Reservation System
            </Typography>

            <Typography sx={{ color: 'text.secondary', mb: 5 }} />

            <LoginForm defaultValues={defaultValues} LoginOnSubmit={() => LoginOnSubmit} />
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
